import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-badge-estados-contrato',
  templateUrl: './badge-estados-contrato.component.html',
  styleUrls: ['./badge-estados-contrato.component.css'],
})
export class BadgeEstadosContratoComponent {
  @Input() idEstado!: number;
  @Input() descripcionEstado?: string;
  @Input() soloIcono: boolean = false; // Para mostrar solo el ícono

  getEstadoIcon(idEstado: number): string {
    const iconMap: { [key: number]: string } = {
      1: 'check_circle',        // Activo
      2: 'done_all',            // Finalizado
      3: 'cancel',              // Rescindido

    };
    return iconMap[idEstado] || 'info';
  }

  getEstadoClass(idEstado: number): string {
    const classMap: { [key: number]: string } = {
      1: 'estado-activo',
      2: 'estado-finalizado',
      3: 'estado-rescindido'
    };
    return classMap[idEstado] || '';
  }

  getEstadoDescripcion(idEstado: number): string {
    const descripcionMap: { [key: number]: string } = {
      1: 'Activo',
      2: 'Finalizado',
      3: 'Rescindido',
    };
    return this.descripcionEstado || descripcionMap[idEstado] || 'Desconocido';
  }
}
